module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "realData"
  }, [_c('page-header'), _vm._v(" "), (!_vm.isMobile) ? _c('el-row', {
    staticClass: "set-option",
    attrs: {
      "type": "flex",
      "justify": "space-between",
      "align": "middle"
    }
  }, [_c('el-col', {
    attrs: {
      "span": 3
    }
  }, [_c('el-select', {
    staticClass: "charts-input",
    attrs: {
      "placeholder": "窑号"
    },
    on: {
      "change": _vm.loadBrick
    },
    model: {
      value: (_vm.option.aliasNo),
      callback: function($$v) {
        _vm.option.aliasNo = $$v
      },
      expression: "option.aliasNo"
    }
  }, _vm._l((_vm.sys_alias), function(item) {
    return _c('el-option', {
      key: item.val,
      attrs: {
        "label": item.label,
        "value": item.val
      }
    })
  }))], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 3
    }
  }, [_c('el-select', {
    staticClass: "charts-input",
    attrs: {
      "placeholder": "类型"
    },
    model: {
      value: (_vm.option.selectType),
      callback: function($$v) {
        _vm.option.selectType = $$v
      },
      expression: "option.selectType"
    }
  }, _vm._l((_vm.chartsType), function(item) {
    return _c('el-option', {
      key: item.val,
      attrs: {
        "label": item.label,
        "value": item.val
      }
    })
  }))], 1), _vm._v(" "), (_vm.stand.list && _vm.stand.list.length) ? _c('el-col', {
    staticClass: "chars-title",
    attrs: {
      "span": 12
    }
  }, [_c('el-select', {
    staticClass: "charts-input",
    attrs: {
      "placeholder": "请选择砖类型"
    },
    on: {
      "change": _vm.changeStandType
    },
    model: {
      value: (_vm.stand.type),
      callback: function($$v) {
        _vm.stand.type = $$v
      },
      expression: "stand.type"
    }
  }, _vm._l((_vm.stand.list), function(item, index) {
    return _c('el-option', {
      key: index,
      attrs: {
        "label": index + ':' + item[index],
        "value": index
      }
    })
  })), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "text"
    },
    on: {
      "click": _vm.openSetStandType
    }
  }, [_vm._v("砖类型设置")])], 1) : _vm._e(), _vm._v(" "), _c('el-col', {
    staticStyle: {
      "text-align": "right"
    },
    attrs: {
      "span": 6
    }
  }, [_c('div', {
    staticStyle: {
      "padding": "0 10px"
    }
  }, [_c('el-button', {
    attrs: {
      "type": "primary",
      "loading": _vm.loading.standard
    },
    on: {
      "click": function($event) {
        _vm.saveStandConf(true)
      }
    }
  }, [_vm._v("\n                    " + _vm._s(_vm.loading.standard ? '正在加载' : '同步设置至设备') + "\n                ")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary",
      "loading": _vm.loading.standard
    },
    on: {
      "click": function($event) {
        _vm.loadStandConf(false)
      }
    }
  }, [_vm._v("\n                    " + _vm._s(_vm.loading.standard ? '正在加载' : '刷新数据') + "\n                ")])], 1)])], 1) : _vm._e(), _vm._v(" "), (_vm.isMobile) ? _c('div', {
    staticClass: "mobile-top-bar"
  }, [_c('div', [_c('div', [_c('el-select', {
    staticClass: "charts-input",
    attrs: {
      "size": "small",
      "placeholder": "窑号"
    },
    on: {
      "change": _vm.loadBrick
    },
    model: {
      value: (_vm.option.aliasNo),
      callback: function($$v) {
        _vm.option.aliasNo = $$v
      },
      expression: "option.aliasNo"
    }
  }, _vm._l((_vm.sys_alias), function(item) {
    return _c('el-option', {
      key: item.val,
      attrs: {
        "label": item.label,
        "value": item.val
      }
    })
  }))], 1), _vm._v(" "), (_vm.stand.list && _vm.stand.list.length) ? _c('div', [_c('el-select', {
    staticClass: "charts-input",
    attrs: {
      "size": "small",
      "placeholder": "请选择砖类型"
    },
    on: {
      "change": _vm.changeStandType
    },
    model: {
      value: (_vm.stand.type),
      callback: function($$v) {
        _vm.stand.type = $$v
      },
      expression: "stand.type"
    }
  }, _vm._l((_vm.stand.list), function(item, index) {
    return (item[index]) ? _c('el-option', {
      key: index,
      attrs: {
        "label": item[index],
        "value": index
      }
    }) : _vm._e()
  }))], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticStyle: {
      "text-align": "right"
    }
  }, [_c('el-select', {
    staticClass: "charts-input",
    attrs: {
      "size": "small",
      "placeholder": "类型"
    },
    model: {
      value: (_vm.option.selectType),
      callback: function($$v) {
        _vm.option.selectType = $$v
      },
      expression: "option.selectType"
    }
  }, _vm._l((_vm.chartsType), function(item) {
    return _c('el-option', {
      key: item.val,
      attrs: {
        "label": item.label,
        "value": item.val
      }
    })
  }))], 1)]), _vm._v(" "), _c('div', [_c('el-button', {
    on: {
      "click": _vm.openSetStandType
    }
  }, [_vm._v("砖类型设置")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "loading": _vm.loading.standard
    },
    on: {
      "click": function($event) {
        _vm.saveStandConf(true)
      }
    }
  }, [_vm._v("\n                " + _vm._s(_vm.loading.standard ? '正在加载' : '同步设置至设备') + "\n            ")])], 1)]) : _vm._e(), _vm._v(" "), [(_vm.loading.standard) ? _c('el-card', {
    staticClass: "box-card  css-margin-top no-padding"
  }, [_c('loading')], 1) : _vm._l((_vm.standConf), function(itemType, key) {
    return _c('el-card', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (itemType && itemType.length && _vm.option.selectType === key),
        expression: "itemType&&itemType.length&&option.selectType===key"
      }],
      key: key,
      staticClass: "box-card  css-margin-top no-padding"
    }, [_c('div', {
      staticClass: "clearfix chars-header"
    }, [_c('span', {
      staticClass: "card-header-title"
    }, [_vm._v(_vm._s(_vm.confTypeName[key]) + "\n        "), _c('span', [_vm._v("（单位：℃)")])]), _vm._v(" "), (!_vm.isMobile) ? _c('div', [(_vm.isEdit) ? _c('el-button', {
      attrs: {
        "type": "text"
      },
      on: {
        "click": function($event) {
          _vm.isEdit = false
        }
      }
    }, [_vm._v("取消")]) : _vm._e(), _vm._v(" "), _c('el-button', {
      attrs: {
        "type": _vm.isEdit ? 'success' : 'text'
      },
      on: {
        "click": _vm.openEdit
      }
    }, [_vm._v(_vm._s(_vm.isEdit ? "保存并写入设备" : "编辑") + "\n                    ")])], 1) : _vm._e()]), _vm._v(" "), _c('div', {
      staticClass: "card-body "
    }, [_c('div', {
      staticClass: "leemma-table"
    }, _vm._l((itemType), function(item) {
      return _c('div', {
        key: item.id
      }, [_c('div', {
        staticClass: "leemma-table-th"
      }, [_vm._v("\n                            " + _vm._s(item.key) + "\n                        ")]), _vm._v(" "), _c('div', {
        staticClass: "leemma-table-td"
      }, [(!_vm.isEdit) ? _c('p', [_vm._v(_vm._s(item.data))]) : _c('el-input', {
        model: {
          value: (item.data),
          callback: function($$v) {
            item.data = $$v
          },
          expression: "item.data"
        }
      })], 1)])
    }))])])
  }), _vm._v(" "), _c('el-card', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.loading.echarts),
      expression: "!loading.echarts"
    }],
    staticClass: "box-card  css-margin-top quxian"
  }, [_c('div', {
    staticClass: "clearfix chars-header"
  }, [_c('span', {
    staticClass: "card-header-title"
  }, [_vm._v("标准参数对比曲线\n                    "), _c('span', [_vm._v("（单位：℃)")])]), _vm._v(" "), _c('div', {
    staticClass: "time-show"
  }, [_vm._v("\n                    " + _vm._s(_vm.option.time_stamp) + "\n\n                ")]), _vm._v(" "), _c('span')]), _vm._v(" "), (!_vm.oldConf) ? _c('div', {
    staticClass: "img-no-data"
  }, [_c('img', {
    attrs: {
      "src": _vm.img_no_data,
      "alt": "暂无数据"
    }
  }), _vm._v(" "), _c('p', [_vm._v("暂无数据")])]) : _c('div', [_c('div', {
    ref: "charts"
  })])])], _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "砖类型设置",
      "visible": _vm.dialog.standType,
      "size": "large"
    },
    on: {
      "update:visible": function($event) {
        _vm.dialog.standType = $event
      }
    }
  }, [_c('div', {
    staticClass: "dialog-body"
  }, [_c('el-form', {
    staticClass: "demo-form-inline",
    attrs: {
      "inline": true,
      "label-width": "30px"
    }
  }, _vm._l((_vm.stand.list), function(item, index) {
    return _c('el-form-item', {
      key: index,
      attrs: {
        "label": index.toString()
      }
    }, [_c('el-input', {
      attrs: {
        "maxlength": 20,
        "placeholder": "砖类型"
      },
      model: {
        value: (item[index]),
        callback: function($$v) {
          var $$exp = item,
            $$idx = index;
          if (!Array.isArray($$exp)) {
            item[index] = $$v
          } else {
            $$exp.splice($$idx, 1, $$v)
          }
        },
        expression: "item[index]"
      }
    })], 1)
  }))], 1), _vm._v(" "), _c('span', {
    staticClass: "dialog-footer",
    slot: "footer"
  }, [_c('el-button', {
    on: {
      "click": _vm.saveStandType
    }
  }, [_vm._v("保存")]), _vm._v(" "), _c('el-button', {
    on: {
      "click": function($event) {
        _vm.dialog.standType = false
      }
    }
  }, [_vm._v("关闭")])], 1)])], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6bdb261a"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/tempControl/standardSet.vue
// module id = 925
// module chunks = 1